(function () {
    'use strict';

    angular.module('iMatApp')
        .controller('ProductDesignerController', ProductDesignerController);

    ProductDesignerController.$inject = ['$scope', '$log', 'mainWorkspace', 'leadTimesService', 'productSalesPriceProvider', 'upload3DModelSettings'];

    function ProductDesignerController($scope, $log, mainWorkspace, leadTimesService, productSalesPriceProvider, settings) {
        var vm = this;
        
        vm.expressMaterialShipmentDateMessage = null;
        vm.options = mainWorkspace.options;

        vm.getProduct = getProduct;
        vm.getMaterials = getMaterials;

        vm.isProductProcessing = isProductProcessing;
        vm.getProductProcessingStateKey = getProductProcessingStateKey;

        vm.getSalesPrice = getSalesPrice;
        vm.getMaterialSalesPrice = getMaterialSalesPrice;
        vm.getColourSalesPrice = getColourSalesPrice;

        vm.getIssue = getIssue;
        
        vm.addToCartVisible = addToCartVisible;
        vm.addToCartEnable = addToCartEnable;

        vm.getMaterialInfoUrl = getMaterialInfoUrl;
        vm.getColourUrl = getColourUrl;

        activate();

        // -------------------------------------------------------------

        function activate() {
            $scope.$watch(function () {
                var material = mainWorkspace.product.material();
                var colour = mainWorkspace.product.colour();

                if (!material || !colour) {
                    return null;
                }

                return {
                    materialId: mainWorkspace.product.material().id,
                    colourId: mainWorkspace.product.colour().id
                };
            }, materialColourChanged, true);

            $scope.$watch(function () {
                return mainWorkspace.product.model.id;
            }, modelChanged, true);
        }

        function getProduct() {
            return mainWorkspace.product;
        }

        function getMaterials() {
            return mainWorkspace.materials;
        }

        // -------------------------------------------- Lead-times -----------------------------------------

        function modelChanged() {
            productSalesPriceProvider.clearCache();
        }

        function materialColourChanged() {
            var material = mainWorkspace.product.material();
            var colour = mainWorkspace.product.colour();

            initLeadTimeForExpressMaterialColour(material, colour);
        }

        function initLeadTimeForExpressMaterialColour(material, colour) {
            if (!material || !material.isExpress) {
                return;
            }

            leadTimesService.getLeadTime(material.id, colour.id)
                .then(function (shipmentDate) {
                    vm.expressMaterialShipmentDateMessage = shipmentDate.message;
                });
        }

        // -------------------------------------------- Statuses -----------------------------------------

        function isProductProcessing() {
            return mainWorkspace.product.isProcessing();
        }

        function getProductProcessingStateKey() {
            var product = mainWorkspace.product;
            switch (product.state) {
                case 'ModelProcessing':
                    return getModelProcessingStateKey(product.model);
                default:
                    return null;
            }
        }

        function getModelProcessingStateKey(model) {
            switch (model.state) {
                case 'FileUploading':
                    return 'upload-3d-model-js_uploading-state';

                case 'ModelCreating':
                    return 'upload-3d-model-js_analyzing-state';

                case 'WaitProcessingResult':
                    return getModelProcessingStatusKey(model.status);

                default:
                    return null;
            }
        }

        function getModelProcessingStatusKey(status) {
            if (status.isAnalysing() || status.isUnknown()) {
                return 'upload-3d-model-js_analyzing-state';
            } else if (status.isFixing()) {
                return 'upload-3d-model-js_fixing-state';
            } else if (status.isMediumFixing()) {
                return 'upload-3d-model-js_medium-fixing-state';
            } else if (status.isAdvancedFixing()) {
                return 'upload-3d-model-js_advanced-fixing-state';
            }

            return null;
        }

        // -------------------------------------------- Prices -----------------------------------------

        function getSalesPrice() {
            return productSalesPriceProvider.getSalesPrice(mainWorkspace.product);
        }

        function getMaterialSalesPrice(material) {
            return productSalesPriceProvider.getMaterialSalesPrice(mainWorkspace.product, material);
        }

        function getColourSalesPrice(colour) {
            var material = mainWorkspace.product.material();
            return productSalesPriceProvider.getColourSalesPrice(mainWorkspace.product, material, colour);
        }

        // ------------------------------------------ Issues -------------------------------------------

        function getIssue() {
            if (mainWorkspace.issue) {
                return mainWorkspace.issue;
            }

            if (mainWorkspace.product.model.issue) {
                return mainWorkspace.product.model.issue;
            }

            var salesPrice = getSalesPrice();
            if (salesPrice && salesPrice.issue) {
                return salesPrice.issue;
            }

            return null;
        }

        // ------------------------------------------ Issues -------------------------------------------

        function addToCartVisible() {
            var issue = getIssue();

            if (!issue) {
                return true;
            }

            if (issue.isQuestion()) {
                return false;
            }

            return !issue.actions || !issue.actions.length;
        }

        function addToCartEnable() {
            var price = getSalesPrice();
            if (!price) {
                return false;
            }

            if (!price.hasPrice()) {
                return false;
            }

            return true;
        }

        // ------------------------------------------ Urls -------------------------------------------

        function getMaterialInfoUrl(material) {

            if (!material || !material.urlFriendlyName) {
                return null;
            }

            return settings.materialPageUrl.replace('PLACEHOLDER', material.urlFriendlyName);
        }

        function getColourUrl(material) {

            if (!material || !material.urlFriendlyName) {
                return null;
            }

            return settings.materialColorsAndFinishesUrl.replace('PLACEHOLDER', material.urlFriendlyName);
        }
    }
})();